__turbopack_context__.v({
  "loggedInUser": "wOqyKG_loggedInUser",
  "loggedInUserEmail": "wOqyKG_loggedInUserEmail",
  "loggedInUserLabel": "wOqyKG_loggedInUserLabel",
  "popupHeader": "wOqyKG_popupHeader",
  "profileButton": "wOqyKG_profileButton",
  "profileMenuDropdown": "wOqyKG_profileMenuDropdown",
  "tabletContent": "wOqyKG_tabletContent",
  "title": "wOqyKG_title",
});
